import styled from 'styled-components'
import { useState, useLayoutEffect, useRef } from 'react'
import { products } from '../utils/constants'
import React from 'react'


const Products = () => {

    const headerRef = useRef(null)
    const [canSee, setCanSee] = useState(false)
    const classes = canSee ? 'header anime' : 'header'

    useLayoutEffect(() => {
        const onScroll = () => {
            const headerTop = headerRef.current.getBoundingClientRect().top;
            const reached = headerTop < window.innerHeight;
            setCanSee(reached);
        }

        window.addEventListener('scroll', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
        };
    })

    return (
        <Wrapper>
            <div id="products" className="top-space"></div>
            <h1>Products</h1>
            <h2
            ref={headerRef}
            className={classes}
            >Quality is Pride of Workmanship!</h2>
            <section id="product-deck">
                {products.map((product) => {
                return <Product key={product.id} {...product}
                />
                })}
            </section>
            <div className="button-wrapper">
                <a href='/gallery/#categories'>
                    <button>
                            View More
                    </button>
                </a>
            </div>
        </Wrapper>
    )
}

const Product = React.memo(({ name, img }) => {
    const  productRef = useRef(null)
    const [canSee, setCanSee] = useState(false)
    const classes = canSee ? 'product-wrapper view' : 'product-wrapper';

    useLayoutEffect(() => {
        const onScroll = () => {
            const productTop = productRef.current.getBoundingClientRect().top;
            const reached = productTop < window.innerHeight;
            setCanSee(reached);
        }

        window.addEventListener('scroll', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
        };
    })



    return(
        <div
        className={classes}
        ref={productRef}
        >
            <img src={img} alt={name} />
            <h3>{name}</h3>
        </div>
    )
})

const Wrapper = styled.section`
    min-height: 100vh;
    background: #fff;
    padding-bottom: 4rem;
    h1 {
        font-weight: 700;
        text-align: center;
        margin-top: 3rem;
        font-size: 2rem
    }
    h2 {
        text-align: center;
        margin-top: 1.5rem;
        transform: translateX(80%);
        transition: transform 1s ease-in;
    }
    .anime {
        transform: translateX(0%);
    }
    #product-deck {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        perspective: 1500px;
    }
    .product-wrapper {
        margin: 1.5rem 1.5rem 0;
        transform: rotateX(100deg);
        transform-style: preserve-3d;
        transition: all 2s ease-out;
    }
    .view {
        transform: rotateX(0deg)
    }
    img {
        width: 224px;
        height: 200px;
        border-radius: 20px;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    button {
        color: #fff;
        background: #000;
        margin-top: 4rem;
        padding: 1rem;
        font-size: 1rem;
        font-weight: 700;
        border: 2px solid white;
        border-radius: 50px;
        transition: all 0.3s ease-in;
        animation: button-anime 2s ease-out 0s infinite;
    }
    a {
        text-decoration: none;
        color: #fff;
    }
    @keyframes button-anime {
        20% {
            background: rgba(0,0,0,1)
        }
        40% {
            background: rgba(0,0,0,0.4)
        }
        60% {
            background: rgba(0,0,0,0.8);
        }
        80% {
            background: rgba(0,0,0,0.2);
        }
        100% {
            background: rgba(0,0,0,1);
        }
    }
    @media screen and (min-width: 440px) {
        img {
            width: 280px;
            height: 250px;
        }
        .product-wrapper {
            margin: 3rem 3rem 0;
        }
    }
    @media screen and (max-width: 300px) {
        img {
            width: 180px;
            height: 162px;
        }
        .product-wrapper {
            margin: 1rem 1rem 0;
        }
    }
    h3 {
        text-align: center;
    }
    @media screen and (max-width: 440px) {
        h2 {
            font-size: 1.3rem;
        }
    }
`

export default React.memo(Products)
